import type {UserAvatarData} from '@Libraries/user-avatar.types';

export enum UserAvatarSize {
  /** 16px: inline in a one-line byline. */
  XXS = 'xxs',
  /** 24px: inline next to a name. */
  XS = 'xs',
  /** 28px: the editor's presence roster. */
  SM = 'sm',
  /** 32px: list rows and stacked team avatars. */
  MD = 'md',
  /** 40px: an account row. */
  LG = 'lg',
  /** 64px: a single-account card or a profile header. */
  XL = 'xl',
}

export interface UserAvatarProps {
  avatar: UserAvatarData;
  /** Read out for the picture and shown on hover; the initial alone is decorative. */
  name: string;
  size: UserAvatarSize;
  /** True when the name is rendered as text right beside the avatar, so assistive tech is not told it twice. */
  hasNameBeside?: boolean;
  className?: string;
}

/** The SVG's own coordinate box; the rendered size comes from CSS and the letter scales with it. */
export const AVATAR_VIEWBOX_SIZE = 40;

/** The letter is half the circle, as the co-editing design and most avatar systems draw it. */
export const AVATAR_INITIAL_FONT_SIZE = AVATAR_VIEWBOX_SIZE / 2;
